
import { Layout as DashboardLayout } from 'src/layouts/dashboard/layout';
import { useEffect, useState } from 'react';
import rideService from 'src/services/rideService';
import UpdatePopup from 'src/sections/settings/UpdatePopup';

const Setting = () => {
  const [ratePerKm, setRatePerKm] = useState([]);
  const [isUpdatePopupOpen, setIsUpdatePopupOpen]=useState();
  const [vehicleId,setVehicleId]=useState();
  const[ vehicleRate, setVehicleRate]=useState();
  const[ commissionPercentage, setCommissionPercentage]=useState();
  useEffect(() => {
    rideRatePerKm();
  }, [])

  const rideRatePerKm = async () => {
    await rideService.allRideRatePerKm().then((res) => {
      setRatePerKm(res.data);
    })
  }

  const handleUpdateOpenPopup = (selectedVehicle, vehicleRate, commissionPercentage) => {
   
    setVehicleId(selectedVehicle);
    setIsUpdatePopupOpen(true);
    setVehicleRate(vehicleRate);
    setCommissionPercentage(commissionPercentage)
   
  };
  const handleClosePopup = () => {
    setIsUpdatePopupOpen(false);
   
  };

  const handleUpdate = () => {
    // Perform the update logic here
  
  };

  return (
    <>
     
      <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Ride Rates</h2>
      <table className="table-auto w-full bg-white shadow-md rounded-lg overflow-hidden">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Vehicle</th>
            <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Rate per km</th>
            <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Commission Percentage(%)</th>
            <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Actions</th>
          </tr>
        </thead>
        <tbody>
          {ratePerKm.map(rate => (
          
            <tr key={rate.id} className="hover:bg-gray-50">
         
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{rate.vehicle_type}</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{rate.rate_per_km} per km</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{rate.commission_percentage	}%</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                <button
                  className="bg-indigo-500 text-white py-2 px-4 rounded-md hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600"
                  onClick={() => handleUpdateOpenPopup(rate.id, rate.rate_per_km, rate.commission_percentage)}
                >
                  Update
                </button>
                <UpdatePopup
                isOpen={isUpdatePopupOpen}
                onClose={handleClosePopup}
                onSubmit={handleUpdate}
                vehicleId={vehicleId}
                initialVehicleRate={vehicleRate}
                initialCommissionPercentage={commissionPercentage}
                />
                {/* <button
                  className="text-red-600 hover:underline"
                  onClick={() => handleDelete(rate.id)}
                >
                  Delete
                </button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
      
    </>
  )

};



export default Setting;
